import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { rolesApis } from '../../constants/roles-api';
import { TenantNode } from '../../interfaces/tenant/tenant.interface';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
    public tenantDropdown$ = new BehaviorSubject<TenantNode[]>([]);
    public selectedTenantDropdown$ = new BehaviorSubject<any[]>([]);
    permissions_entity = permissionEntity;
    
    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) {}

    /* Get Roles */
    getRoles(pagination: PaginationType, filters?: any, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.user_groups);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${rolesApis.roles}${query}`);
    }

     /* Get Role By ID */
     getRoleByID(id:string): Observable<any> {
        return this.httpClientService.get(rolesApis.getRoleById.replace(':rolesId', id));
    }

    /* Post Role */
    postRole(payload: any): Observable<any> {
        return this.httpClientService.post(
            rolesApis.roles,
            payload
        );
    }

    /* Edit Role */
    editRole(payload: any, roleId: string): Observable<any> {
        return this.httpClientService.put(`${rolesApis.editRoles}?roleId=${roleId}`, payload);
    }

    /* Delete Role */
    deleteRole(): Observable<any> {
        return this.httpClientService.delete(rolesApis.roles);
    }

    getRolesUser(): Observable<any> {
        return this.httpClientService.get(`${rolesApis.getRolesUser}`);
    }
}
